export const enum EProductType {
  Package = 'package',
  Subscription = 'subscription',
}
